// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c9ee7ed","455":"95b4b3b1","977":"6fc42e20"}[chunkId] + ".chunk.js";
};